import { render, staticRenderFns } from "./PaymentJournalProcess.vue?vue&type=template&id=66dacad4"
import script from "./PaymentJournalProcess.vue?vue&type=script&lang=js"
export * from "./PaymentJournalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66dacad4')) {
      api.createRecord('66dacad4', component.options)
    } else {
      api.reload('66dacad4', component.options)
    }
    module.hot.accept("./PaymentJournalProcess.vue?vue&type=template&id=66dacad4", function () {
      api.rerender('66dacad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentJournalProcess.vue"
export default component.exports